import { Component, HostBinding, Injector } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, NavigationEnd, Router } from '@angular/router';
import { DxLoadPanelModule } from 'devextreme-angular';
import { filter, Observable } from 'rxjs';
import { AuthService, ScreenService, AppInfoService } from './shared/services';
import { ServiceInjector } from './classes/infrastructure/injector';
import { GlobalLoaderService } from './services/global_loader.service';
import { BreadcrumbAutoService } from './services/breadcrumb-auto.service';
import { SideNavInnerToolbarComponent } from './layouts/side-nav-inner-toolbar/side-nav-inner-toolbar.component';
import { UnauthenticatedContentComponent } from './unauthenticated-content';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    DxLoadPanelModule,
    SideNavInnerToolbarComponent,
    UnauthenticatedContentComponent,
  ],
})
export class AppComponent {
  currentUrl: string = '';
  loading$!: Observable<boolean>;
  loaderText = "";                 // e.g. "Loading..."

  @HostBinding('class') get getClass() {
    const sizeClassName = Object.keys(this.screen.sizes).filter(cl => this.screen.sizes[cl]).join(' ');
    return `${sizeClassName} app`;
  }

  constructor(private authService: AuthService, private injector: Injector, private screen: ScreenService,
    public appInfo: AppInfoService, public router: Router, public loader: GlobalLoaderService, private breadcrumbAuto: BreadcrumbAutoService) {
    this.loading$ = this.loader.isLoading$;
    ServiceInjector.AppInjector = this.injector;
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.currentUrl = event.urlAfterRedirects;
    });

    this.breadcrumbAuto.init();
  }

  isAuthenticated() {
    return this.authService.loggedIn;
  }

  isAuthPage(): boolean {
    return ['/Landing_Page', '/login-form', '/reset-password', '/create-account', '/forgot-password', '/create-new-password', '/otp-verification', '/Change_Password', '/privacy-policy', '/terms-conditions'].includes(this.currentUrl);
  }
}
